const header = document.querySelector('header');
const openNavTrigger = header.querySelector('.top-bar__btn');
const navTopBar = header.querySelector('.top-bar');
const closeNavTrigger = document.querySelector('.top-bar__drawer__close__btn');

openNavTrigger.addEventListener('click', function() {
    toggleClass(navTopBar, 'top-bar--is-open');
});

closeNavTrigger.addEventListener('click', function() {
    toggleClass(navTopBar, 'top-bar--is-open');
});

function toggleClass(element, className) {
    if (element.classList.contains(className)) {
        element.classList.remove(className);
    } else {
        element.classList.add(className);
    }
}

const languageSwitcher = document.getElementById('lang-switcher');

languageSwitcher.addEventListener('change', function() {
    let target = this.value;
    // TODO: cleaner solution than checking map?
    let map = document.getElementById('canton-map');
    if(map) {
        let sr = parseInt(map.dataset.sr);
        if(sr) {
            target += '/standerat';
        }
    }
    window.location = target;
});

const headerFilter = document.getElementById('search-input');
const filterResults = header.querySelectorAll('.search__results.search__results--negative ul li');

headerFilter.addEventListener('keyup', function() {
    for (let i = 0, len = filterResults.length; i < len; i++) {
        let filterResultsSpans = filterResults[i].querySelectorAll('span');

        for (let j = 0, leng = filterResultsSpans.length; j < leng; j++) {
            if (filterResultsSpans[j].innerHTML.toLowerCase().includes(this.value.toLowerCase())) {
                filterResults[i].classList.remove('hidden');
                break;
            }
          
            filterResults[i].classList.add('hidden');
        }
    }
});